module.exports = __webpack_public_path__ + "assets/img/success.4287b647.png";